import { Integration } from '@futrli-sdk/app-store';

import { ApiView, ApiViewState, getDefaultApiViewState } from '../../../core/ApiView';
import { integrationsQuery } from '../../../queries/integrations';

export interface IntegrationsViewState extends ApiViewState {
  integrations: Integration[] | undefined;
}

export class IntegrationsView extends ApiView {
  private integrationsObs: ReturnType<typeof integrationsQuery>;

  public state: IntegrationsViewState = {
    ...getDefaultApiViewState(),
    integrations: undefined
  };

  constructor(enabled = true) {
    super();
    this.integrationsObs = this.addQuery(integrationsQuery({ enabled }));
    this.updateState();
  }

  public subscribeToObservers(): void {
    this.addUnsubscribe(this.integrationsObs.subscribe(() => this.notify()));
    this.notify();
  }

  protected getNewState(): IntegrationsViewState {
    return {
      ...super.getNewState(),
      integrations: this.integrations
    };
  }

  private get integrations() {
    return this.getResult(this.integrationsObs).data;
  }
}
